<template>
	<v-card tile elevation="0" class="arp-aba-informacoes">
		<v-card-text>
			<v-form v-model="isFormValid" ref="formAdicionarPenalidade" lazy-validation>
				<v-row>
					<v-col cols="12" sm="4">
						<label-personalizado nome-campo="Fornecedor" obrigatorio-por-padrao></label-personalizado>
						<v-autocomplete
							id="modal-penalidade-selecionar-fornecedor"
							v-model="fornecedor"
							:items="fornecedoresDataSource"
							:rules="fornecedorRules"
							placeholder="Selecione"
							class="ma-0 py-0 pt-3 mt-1"
							item-value="idPessoa"
							item-text="nomeFornecedor"
							dense
							clearable
							:disabled="modoVisualizacao || isDesabilitarCampoFornecedor"
						>
						</v-autocomplete>
					</v-col>
					<v-col cols="12" sm="4">
						<label-personalizado nome-campo="Sanção" obrigatorio-por-padrao></label-personalizado>
						<v-autocomplete
							id="modal-penalidade-selecionar-tipo"
							v-model="tipoSancao"
							:items="tipoSancaoDataSource"
							:rules="tipoRules"
							placeholder="Selecione"
							class="ma-0 py-0 pt-3 mt-1"
							item-value="id"
							item-text="nome"
							dense
							return-object
							clearable
							:disabled="modoVisualizacao"
						>
						</v-autocomplete>
					</v-col>
					<v-col cols="12" sm="4">
						<label-personalizado nome-campo="Órgão" obrigatorio-por-padrao></label-personalizado>
						<v-autocomplete
							id="modal-penalidade-selecionar-orgao-sancionador"
							v-model="orgaoSancionadorSelecionado"
							:items="orgaoSancionadorDataSource"
							:rules="orgaoSancionadorRules"
							placeholder="Selecione"
							class="ma-0 py-0 pt-3 mt-1"
							item-value="id"
							item-text="sigla"
							dense
							clearable
							:disabled="modoVisualizacao || !fornecedorSelecionado"
						>
						</v-autocomplete>
					</v-col>
				</v-row>

				<v-row>
					<v-col cols="12" sm="4">
						<label-personalizado nome-campo="Nº Processo"></label-personalizado>
						<v-text-field
							id="modal-penalidade-numero-processo"
							v-model.trim="numeroProcesso"
							clearable
							maxlength="50"
							counter="50"
							type="string"
							class="pt-3 mt-1"
							placeholder="Informe"
							:disabled="modoVisualizacao"
						>
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="4">
						<input-text-de-data
							nome-do-campo="Data Início"
							:value.sync="dataInicio"
							:validation-rules="DataInicioRules"
							:is-obrigatorio="false"
							permitir-limpar-data
							:disabled="modoVisualizacao"
						></input-text-de-data>
					</v-col>
					<v-col cols="12" sm="4">
						<input-text-de-data
							nome-do-campo="Data Término"
							:validation-rules="DataTerminoRules"
							:value.sync="dataTermino"
							:is-obrigatorio="false"
							permitir-limpar-data
							:disabled="modoVisualizacao"
						></input-text-de-data>
					</v-col>
				</v-row>

				<v-row>
					<v-col cols="12">
						<label-personalizado obrigatorio-por-padrao nome-campo="Motivo"></label-personalizado>
						<v-textarea
							ref="modal-penalidade-motivo"
							v-model.trim="motivoPenalidade"
							:rules="motivoPenalidadeRules"
							auto-grow
							counter="300"
							placeholder="Informe"
							no-resize
							rows="3"
							:disabled="modoVisualizacao"
						></v-textarea>
					</v-col>
				</v-row>

				<v-row>
					<v-col cols="12" sm="4">
						<input-text-de-data
							nome-do-campo="Data Publicação"
							:value.sync="dataPublicacao"
							:is-obrigatorio="false"
							permitir-limpar-data
							:disabled="modoVisualizacao"
						></input-text-de-data>
					</v-col>
					<v-col cols="12" sm="4">
						<label-personalizado nome-campo="Contrato/Processo Compra"></label-personalizado>
						<v-text-field
							id="modal-penalidade-contrato-processo-compra"
							v-model.trim="contratoOuProcessoCompra"
							clearable
							type="string"
							maxlength="50"
							counter="50"
							class="ma-0 py-0 pt-3 mt-1"
							placeholder="Informe"
							:disabled="modoVisualizacao"
						>
						</v-text-field>
					</v-col>
					<v-col cols="12" sm="4">
						<label-personalizado nome-campo="Situação"></label-personalizado>
						<v-select
							id="modal-penalidade-situacao"
							v-model="situacaoPenalidade"
							:items="situacaoPenalidadeDataSource"
							placeholder="Selecione"
							class="ma-0 py-0 pt-3 mt-1"
							item-value="value"
							item-text="nome"
							:disabled="isVisualizar"
						>
						</v-select>
					</v-col>
				</v-row>

				<v-row>
					<v-col cols="12" sm="4" v-if="mostrarCampoValor()">
						<label-personalizado nome-campo="Valor"></label-personalizado>
						<az-money
							id="modal-penalidade-valor-multa"
							v-model="valorMulta"
							name="valor-multa"
							placeholder="Informe"
							:negative="false"
							:requeridMessage="'Quantidade deve ser preenchido!'"
							:precision="2"
							:maxLength="300"
							prefix="R$ "
							class="ma-0 py-0 pt-3 mt-1"
							dense
							:disabled="modoVisualizacao"
						></az-money>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script>
import InputTextDeData from '@/views/components/input/InputTextDeData.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import { DataUtils } from '@/core/utils'
import { actionTypes, mutationTypes } from '@/core/constants'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import { mapState } from 'vuex'

export default {
	name: 'penalidade-aba-sancao',
	components: { LabelPersonalizado, InputTextDeData },
	mixins: [validacaoFormulario],
	props: {
		idEntidade: {
			type: [String, Number],
			required: true,
		},
		idAta: {
			type: [String, Number],
			required: true,
		},
		entidadeTipo: {
			type: Object,
			required: true,
		},
		modoVisualizacao: {
			type: Boolean,
			default: false,
		},
		isVisualizar: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isFormValid: false,
			fornecedorRules: [(v) => this.regraObrigatoriedade(v, 'Fornecedor é obrigatório.')],
			tipoRules: [(v) => this.regraObrigatoriedade(v, 'Sanção é obrigatório.')],
			orgaoSancionadorRules: [(v) => this.regraObrigatoriedade(v, 'Orgão é obrigatório.')],
			motivoPenalidadeRules: [
				(v) => v.length <= 300 || 'O campo motivo deve ser igual ou menor do que 300 caracteres.',
				(v) => this.regraObrigatoriedade(v, 'Motivo é obrigatório.'),
			],
			fornecedorSelecionado: null,
			fornecedoresDataSource: [],
			tipoSancaoSelecionada: null,
			tipoSancaoDataSource: [],
			orgaoSancionadorSelecionado: null,
			orgaoSancionadorDataSource: [],
			situacaoPenalidade: 'ATIVO',
			situacaoPenalidadeDataSource: [
				{ nome: 'Ativo', value: 'ATIVO' },
				{ nome: 'Inativo', value: 'INATIVO' },
			],
			numeroProcesso: null,
			dataInicio: '',
			dataTermino: '',
			motivoPenalidade: '',
			contratoOuProcessoCompra: null,
			dataPublicacao: '',
			valorMulta: null,
			DataTerminoRules: [(v) => this.validarDataTermino(v)],
			DataInicioRules: [(v) => this.validarDataInicio(v)],
			isDesabilitarCampoFornecedor: false,
			tipoEntidade: 'SANCAO',
		}
	},
	computed: {
		...mapState({
			orgaoSancionadorSalvo: (state) => state.penalidades.orgaoSancionadorSalvo,
			idPenalidadeSalva: (state) => state.penalidades.idPenalidadeSalva,
			abaSelecionada: (state) => state.penalidades.abaSelecionada,
			salvarSancaoPenalidade: (state) => state.penalidades.salvarSancaoPenalidade,
			efetivarSancaoPenalidade: (state) => state.penalidades.efetivarSancaoPenalidade,
		}),
		fornecedor: {
			get() {
				return this.fornecedorSelecionado
			},
			set(value) {
				this.fornecedorSelecionado = value
				if (this.fornecedorSelecionado) this.buscarOrgaosSancionadores()
				this.orgaoSancionadorSelecionado = null
			},
		},
		tipoSancao: {
			get() {
				return this.tipoSancaoSelecionada
			},
			set(value) {
				this.tipoSancaoSelecionada = value
				if (!this.mostrarCampoValor()) this.valorMulta = null
			},
		},
	},
	watch: {
		abaSelecionada: {
			async handler() {
				if (this.abaSelecionada !== 3) return
				if (this.$refs.formAdicionarPenalidade) this.resetarVariaveis()
				await this.buscarInformacoes()
			},
			immediate: true,
		},
		orgaoSancionadorSelecionado() {
			if (!this.orgaoSancionadorSalvo) return

			const habilitarColunaItens = this.orgaoSancionadorSelecionado === this.orgaoSancionadorSalvo
			this.habilitarOuDesabilitarAbaItens(habilitarColunaItens)
		},
		async salvarSancaoPenalidade() {
			await this.salvarSancao()
		},
		async efetivarSancaoPenalidade() {
			await this.efetivarSancao()
		},
	},
	methods: {
		async buscarFornecedoresPenalidade() {
			const { fornecedores } = await this.$store.dispatch(
				actionTypes.PENALIDADES.BUSCAR_FORNECEDORES_PENALIDADE,
				{ idAta: this.idAta, ...this.montarObjCommon() },
			)
			this.fornecedoresDataSource = fornecedores

			if (fornecedores.length === 1 && !this.idPenalidadeSalva) {
				this.fornecedorSelecionado = fornecedores.at(0).idPessoa
				await this.buscarOrgaosSancionadores()
			}
		},
		async buscarTiposPenalidades() {
			const { itens } = await this.$store.dispatch(actionTypes.PENALIDADES.BUSCAR_TIPOS_PENALIDADE, {
				tipoPenalidade: this.tipoEntidade,
				...this.montarObjCommon(),
			})
			this.tipoSancaoDataSource = itens
		},
		async buscarOrgaosSancionadores() {
			const { orgaosSancionadores } = await this.$store.dispatch(
				actionTypes.PENALIDADES.BUSCAR_ORGAOS_SANCIONADORES_PENALIDADE,
				{
					idAta: this.idAta,
					idPessoa: this.fornecedorSelecionado,
					...this.montarObjCommon(),
				},
			)
			this.orgaoSancionadorDataSource = orgaosSancionadores
			if (orgaosSancionadores.length === 1) this.orgaoSancionadorSelecionado = orgaosSancionadores.at(0).id
		},
		async buscarSancaoPenalidade() {
			if (!this.idPenalidadeSalva) return

			const dados = await this.$store.dispatch(actionTypes.PENALIDADES.BUSCAR_DADOS_GERAIS_PENALIDADE, {
				...this.montarObjCommon(),
				idPenalidade: this.idPenalidadeSalva,
			})

			this.setarValoresNosCampos(dados)
			await this.buscarOrgaosSancionadores()
			this.habilitarOuDesabilitarAbaItens(true)
			this.habilitarAbaDocumentos()
			this.setarValoresNasVariaveisDeControle(dados.isEfetivada)
		},
		async buscarInformacoes() {
			await Promise.all([
				await this.buscarFornecedoresPenalidade(),
				await this.buscarTiposPenalidades(),
				await this.buscarSancaoPenalidade(),
			])
		},
		async efetivarSancao() {
			await this.salvarSancao(true)
		},
		async salvarSancao(isEfetivar) {
			if (this.$refs.formAdicionarPenalidade.validate()) {
				await this.$store
					.dispatch(actionTypes.PENALIDADES.SALVAR_DADOS_GERAIS_PENALIDADE, this.montarObjSancao(isEfetivar))
					.then((resposta) => {
						this.mostrarNotificacaoSucessoDefault()
						this.setarValoresNasVariaveisDeControle(isEfetivar)
						this.$store.commit(mutationTypes.PENALIDADES.SET_ID_PENALIDADE_SALVA, resposta.id)
						this.habilitarOuDesabilitarAbaItens(true)
						this.habilitarAbaDocumentos()
					})
			}
		},
		setarValoresNasVariaveisDeControle(isEfetivada = false) {
			this.$store.commit(mutationTypes.PENALIDADES.SET_ORGAO_SANCIONADOR_SALVO, this.orgaoSancionadorSelecionado)
			this.$store.commit(mutationTypes.PENALIDADES.SET_FORNECEDOR_SALVO, this.fornecedorSelecionado)
			if (isEfetivada) this.$store.commit(mutationTypes.PENALIDADES.SET_IS_PENALIDADE_EFETIVADA)
			this.isDesabilitarCampoFornecedor = true
		},
		habilitarOuDesabilitarAbaItens(habilitar) {
			this.$store.commit(mutationTypes.PENALIDADES.SET_VISIBILIDADE_ABA, { aba: 1, habilitar })
		},
		habilitarAbaDocumentos() {
			this.$store.commit(mutationTypes.PENALIDADES.SET_VISIBILIDADE_ABA, { aba: 2, habilitar: true })
		},
		montarObjSancao(isEfetivar = false) {
			return {
				idEntidade: this.idEntidade,
				tipo: this.entidadeTipo,
				fornecedor: this.fornecedorSelecionado,
				tipoPenalidade: this.tipoSancaoSelecionada.id,
				orgaoSancionador: this.orgaoSancionadorSelecionado,
				numeroProcesso: this.numeroProcesso,
				dataInicio: this.dataInicio,
				dataTermino: this.dataTermino,
				motivoPenalidade: this.motivoPenalidade,
				contratoOuProcessoCompra: this.contratoOuProcessoCompra,
				dataPublicacao: this.dataPublicacao,
				valorMulta: this.valorMulta,
				idPenalidade: this.idPenalidadeSalva,
				situacaoPenalidade: this.situacaoPenalidade,
				isEfetivar,
			}
		},
		setarValoresNosCampos(dados) {
			this.orgaoSancionadorSelecionado = dados?.unidadeOrganizacionalOutput.id
			this.tipoSancaoSelecionada = this.validarSeTipoSancaoExiste(dados?.tipoPenalidadeOutput)
			this.fornecedorSelecionado = this.validarSeFornecedorExiste(dados?.fornecedorOutput)
			this.numeroProcesso = dados?.numeroProcesso
			this.dataInicio = dados?.dataInicio || ''
			this.dataTermino = dados?.dataTermino || ''
			this.dataPublicacao = dados?.dataPublicacao || ''
			this.motivoPenalidade = dados?.motivo || ''
			this.contratoOuProcessoCompra = dados?.contratoProcessoCompra
			this.valorMulta = dados?.valorMulta
			this.situacaoPenalidade = dados?.situacao || 'ATIVO'
		},
		validarSeFornecedorExiste(fornecedor) {
			if (!fornecedor) return null
			this.fornecedoresDataSource = [fornecedor]
			return fornecedor.idPessoa
		},
		validarSeTipoSancaoExiste(tipoSancao) {
			if (!tipoSancao) return null
			if (!this.tipoSancaoDataSource.some((tipo) => tipo.id === tipoSancao.id)) {
				this.tipoSancaoDataSource.push(tipoSancao)
			}

			return tipoSancao
		},
		validarDataTermino() {
			if (!!this.dataInicio && !this.dataTermino) return 'Data término não selecionada.'

			const valida = !DataUtils.isDiferencaEntreDatasMenorIgualA(this.dataInicio, this.dataTermino)
			return valida || 'A data término não pode ser menor que a data de início.'
		},
		validarDataInicio() {
			if (!this.dataInicio && !!this.dataTermino) return 'Data inicio não selecionada.'
			return true
		},
		mostrarCampoValor() {
			if (!this.tipoSancaoSelecionada) return false
			return Object.is(this.tipoSancaoSelecionada.tipo.toLowerCase(), 'multa')
		},
		resetarVariaveis() {
			this.$refs.formAdicionarPenalidade.resetValidation()
			this.setarValoresNosCampos()
		},
		montarObjCommon() {
			return {
				idEntidade: this.idEntidade,
				tipo: this.entidadeTipo,
			}
		},
	},
}
</script>

<style lang="stylus"></style>
